var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "ionicon",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 80a176 176 0 10176 176A176 176 0 00256 80z",
    fill: "none",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 32
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200 202.29s.84-17.5 19.57-32.57C230.68 160.77 244 158.18 256 158c10.93-.14 20.69 1.67 26.53 4.45 10 4.76 29.47 16.38 29.47 41.09 0 26-17 37.81-36.37 50.8S251 281.43 251 296",
    fill: "none",
    stroke: "white",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 28
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 348,
    r: 20,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircleOutline);
export default __webpack_public_path__ + "static/media/help-circle-outline.4ee8a06323399f022c97a0af492bf046.svg";
export { ForwardRef as ReactComponent };